import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {FreeData} from '../message/FreeData';
import {FreeDataCriteria} from './FreeDataCriteria';
import {FreeDataScenario} from './FreeDataScenario';

export class FreeDataWrapper extends BaseWrapper<FreeData, FreeDataCriteria, FreeDataScenario>  {}

